import React, { FunctionComponent } from 'react';
import { ErrorWrapper } from 'components/ErrorPages/ErrorWrapper';

export const Error404Embed: FunctionComponent = () => {
  return (
    <ErrorWrapper type={'event'}>
      <h1>This channel is no longer available</h1>
    </ErrorWrapper>
  );
};
